import { Button } from '@/components/ui/button';
import { ZoomableImage } from '@/components/ZoomableImage';
import { Link } from 'react-router-dom';
import northStarImage from '@/assets/jl-product/01-jl-as-product-public-safe.webp';

export function Hero() {
  return (
    <section id="start" data-guide-label="Start" className="relative overflow-hidden border-b border-ink/5 bg-paper">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-20 md:py-28 lg:grid-cols-[0.78fr_1fr] lg:items-center">
        <div>
          <h1 className="font-display text-4xl leading-[1.05] tracking-tight md:text-6xl lg:text-7xl">
            JL Patawaran
            <br />
            <span className="text-ink/60">AI-Augmented Finance Operator</span>
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-ink/70 md:text-xl">
            Finance craft, systems thinking, and AI-assisted workflows composed
            into one operator-builder for founders who need the books, cash, and
            next decision to line up.
          </p>
          <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Button asChild size="lg" variant="default">
              <Link to="/work-with-me#prefit">Start async prefit</Link>
            </Button>
            <Button asChild size="lg" variant="outline">
              <Link to="/proof">See visual proof</Link>
            </Button>
          </div>
        </div>

        <div className="relative lg:pl-4">
          <div className="overflow-hidden rounded-sm border border-accent/40 bg-white p-2 shadow-[0_24px_70px_rgba(11,13,16,0.12)]">
            <ZoomableImage
              src={northStarImage}
              alt="Public visual showing JL's finance, systems, and AI-assisted operating model"
              label="JL-as-a-Product"
              imageClassName="rounded-[2px]"
              loading="eager"
              width={1233}
              height={1276}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
